import { ArrowRightOutlined, ReloadOutlined } from "@ant-design/icons";
import { Badge, Button, Card, List } from "antd";
import React, { useState } from "react";
import { Link } from "react-router-dom";
import { useAsyncEffect } from "use-async-effect";
import reportService from "../../../services/report.service";
import TimeAgo from "../../shared/timeago/timeago";
import "../home/home.scss";

interface Props {
  init: boolean;
}

const MAX_ORDER_LIMIT = 20;
const DEFAULT_ORDER_LIMIT = 5;
const SHOW_MORE_AMOUNT = 5;

const PendingOrders: React.FC<Props> = ({ init }) => {
  const [loading, setLoading] = useState<boolean>(true);
  const [orders, setOrders] = useState<any[]>([]);
  const [shopId] = useState<string>("all");
  const [limit, setLimit] = useState<number>(DEFAULT_ORDER_LIMIT);
  const [allOrdersFetched, setAllOrdersFetched] = useState<boolean>(false);

  const getPendingOrders = async (reload: boolean) => {
    setLoading(true);

    const response = await reportService.getPendingOrders(shopId, limit);

    if (
      !reload &&
      ((response.orders && response.orders.length === orders.length) ||
        (orders.length === 0 &&
          response.orders &&
          response.orders.length < DEFAULT_ORDER_LIMIT))
    ) {
      setAllOrdersFetched(true);
    }

    setOrders(response.orders || []);
    setLoading(false);
  };

  const handleShowMore = () => {
    setLimit((prev) => prev + SHOW_MORE_AMOUNT);
  };

  useAsyncEffect(async () => {
    getPendingOrders(false);
  }, []);

  useAsyncEffect(async () => {
    getPendingOrders(false);
  }, [limit]);

  return (
    <Card
      className="dashboard-card"
      title={
        <div className="widget-header">
          <span className="widget-title">Pending Orders</span>
          <div className="widget-actions">
            <Button
              onClick={() => getPendingOrders(true)}
              icon={<ReloadOutlined />}
              disabled={loading}
              size="small"
            />
            <Link to="/orders">
              <Button icon={<ArrowRightOutlined />} size="small" />
            </Link>
          </div>
        </div>
      }
    >
      <List
        className="premium-list"
        size="small"
        header={
          <div className="list-info">
            <i>Showing pending orders from the last 24 hours</i>
          </div>
        }
        loading={loading}
        dataSource={orders}
        locale={{ emptyText: "No pending orders found." }}
        renderItem={(item) => (
          <List.Item
            className={item.status}
            actions={[
              <span
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: 10,
                }}
              >
                <Badge
                  count={item.o_totalAmount?.toFixed(2) + " TL"}
                  className="price-badge"
                />
                <TimeAgo date={item.o_createdAt} />
              </span>,
            ]}
          >
            <div>
              <b>{item.o_shopName}</b>
            </div>
          </List.Item>
        )}
      />

      {!loading &&
      limit < MAX_ORDER_LIMIT &&
      !!orders?.length &&
      orders.length < MAX_ORDER_LIMIT &&
      !allOrdersFetched ? (
        <div className="show-more">
          <Button onClick={handleShowMore} type="default">
            Show More
          </Button>
        </div>
      ) : null}
    </Card>
  );
};

export default PendingOrders;
